import { createContext, useContext } from 'react';

// What the page lets every action row do beyond the place's own links: ring the desk
// phone and connect (onCall) and send the place to a guest (onSend). The page provides
// it once, so the Ask console, Right now, the stay plan and place detail all get the
// same buttons without passing handlers through each of them.
const LocalActions = createContext({ onCall: null, onSend: null });

export const LocalActionsProvider = LocalActions.Provider;
export const useLocalActions = () => useContext(LocalActions);
